import api from "./api";
export interface TipoFormularioRural {
    TIPO: number;
    IMOVEL_ID: number;
}

async function alteraImovelRuralForm(tipo: TipoFormularioRural, operation: 'C' | 'U') {
   
    try {
        await api.post(`/imovel-rural/tipo_formulario`, { tipo: tipo.TIPO, imovel_id: tipo.IMOVEL_ID, operation: operation });
        return true;
    } catch (error) {
        console.log(error);
        return false
    }

}

async function getTipoFormularioRural(imovel_id: number) {
    try {
        const { data } = await api.get<TipoFormularioRural[]>(`/imovel-rural/tipo_formulario/${imovel_id}`);
        if (data.length > 0) {
            return data[0]
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }

}



export { alteraImovelRuralForm, getTipoFormularioRural, };